
import IconArrowRight from '~/components/icons/IconArrowRight.vue';

export default {
  components: { IconArrowRight },
  props: {
    backgroundPosition: {
      type: String,
      default: 'center center'
    },
    imageDesktop: {
      type: String,
      required: true
    },
    imageTablet: {
      type: String,
      required: true
    },
    imageMobile: {
      type: String,
      required: true
    }
  }
};
